export enum resetPasswordActions {
  SEND_OTP = 'resetPassword/sendOtp',
  VERIFY_OTP = 'resetPassword/verifyOtp',
  RESEND_OTP = 'resetPassword/resendOtp',
  VERIFY_OTP_FAIL = 'resetPassword/verifyOtpFail',
}

export const recaptchaActions = {
  SEND_OTP: 'sendOtp',
  REGISTER: 'register',
  LOGIN: 'login',
  CHECK_EXISTENCE: 'checkExistence',
};
